import React, { useEffect } from "react"
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom"

import Index from "./components/Index"
import Dashboard from "./modules/Dashboard"
import NotFound from "./modules/NotFound"
import Units from "./modules/Units"
import Tenants from "./modules/Tenants"
import Login from "./components/Login"
import Register from "./components/Register"
import SendEmail from "./modules/SendEmail"

import ProtectedRoute from "./auth/ProtectedRoute"
import PublicRoute from "./auth/PublicRoute"
import Profile from "./components/Profile"
import Rooms from "./components/Rooms"
import Billings from "./modules/Billings"
// import Utilities from "./modules/Utilities"
import { auth } from "./auth/auth"
import Swal from "sweetalert2"
import FloorMap from "./modules/FloorMap"
import Home from "./components/Home"

export const phoneRegex = /^09\d{9}$/
export const LOCALHOST_API = process.env.REACT_APP_LOCALHOST_API_BASE
export const PROD = process.env.REACT_APP_WEBSITE
export const token = localStorage.getItem("token")

export const routes = [
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <Index />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <Navigate to="/units" replace /> },
      { path: "dashboard", element: <Dashboard /> },
      { path: "units", element: <Units /> },
      { path: "tenant", element: <Tenants /> },
      { path: "profile", element: <Profile /> },
      { path: "rooms", element: <Rooms /> },
      { path: "billing", element: <Billings /> },
      // { path: "utilities", element: <Utilities /> },
      { path: "floor-map", element: <FloorMap /> },
      { path: "send-email", element: <SendEmail /> },
      { path: "*", element: <NotFound /> },
    ],
  },

  {
    path: "/home",
    element: (
      <PublicRoute>
        <Home />
      </PublicRoute>
    ),
  },
  {
    path: "/login",
    element: (
      <PublicRoute>
        <Login />
      </PublicRoute>
    ),
  },
  {
    path: "/register",
    element: (
      <ProtectedRoute>
        <Register />
      </ProtectedRoute>
    ),
  },
]

export default function App() {
  useEffect(() => {
    const IDLE_LIMIT = 15 * 60 * 1000
    let idleTimer

    const logoutUser = () => {
      auth.logout()

      Swal.fire({
        icon: "info",
        title: "Logged out",
        text: "You were logged out due to inactivity.",
        timer: 3000,
        timerProgressBar: true,
        confirmButtonColor: "#f97316",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(() => {
        window.location.replace("/login")
      })
    }

    const resetTimer = () => {
      if (!auth.isAuthenticated()) return

      auth.updateActivity()

      clearTimeout(idleTimer)
      idleTimer = setTimeout(logoutUser, IDLE_LIMIT)
    }

    const events = ["mousemove", "mousedown", "keydown", "scroll", "touchstart"]

    events.forEach((e) => window.addEventListener(e, resetTimer))

    resetTimer()

    return () => {
      clearTimeout(idleTimer)
      events.forEach((e) => window.removeEventListener(e, resetTimer))
    }
  }, [])

  return (
    <>
      <Router>
        <Routes>
          {routes.map((route, index) => (
            <Route key={index} path={route.path} element={route.element}>
              {route.children?.map((child, i) => (
                <Route
                  key={i}
                  index={child.index}
                  path={child.path}
                  element={child.element}
                />
              ))}
            </Route>
          ))}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </>
  )
}
